// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Call Center Management Panel - Exact Specifications */

/* Reset and Base Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Monaco', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #F5F7FA;
  color: #1e3a8a;
  line-height: 1.5;
}

/* Main Layout Container */
.app-container {
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

/* Left Sidebar - Exact Specifications */
.sidebar {
  width: 75px; /* 70-80px range, using 75px */
  background-color: #1e3a8a;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 0;
  position: relative;
  z-index: 1000;
}

.sidebar-logo {
  width: 100%;
  height: 72px;
  background-color: #1e3a8a;
  border-radius: 0px;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f09eff;
  font-size: 12px;
  font-weight: 600;
  background-size: 90%;
  background-repeat: no-repeat;
  background-position: center;
}

.sidebar-menu {
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1 1;
}

.sidebar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 12px 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  min-width: 50px;
}

.sidebar-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.sidebar-item.active {
  background-color: rgba(255, 255, 255, 0.15);
  color: white;
}

.sidebar-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.sidebar-label {
  font-size: 10px;
  font-weight: 500;
  text-align: center;
  line-height: 1.2;
}

.sidebar-profile {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  position: relative;
  cursor: pointer;
}

.profile-avatar {
  width: 36px;
  height: 36px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-weight: 600;
}

.profile-name {
  font-size: 9px;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  line-height: 1.2;
}

/* Profile Menu */
.profile-menu {
  position: absolute;
  top: -60px;
  left: 100%;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #E5E7EB;
  z-index: 1000;
  min-width: 180px;
  margin-left: 18px;
  overflow: hidden;
}

.profile-menu-item {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  color: #374151;
  border-bottom: 1px solid #F3F4F6;
}

.profile-menu-item:last-child {
  border-bottom: none;
}

.profile-menu-item:hover {
  background-color: #F9FAFB;
}

.profile-menu-item-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.profile-menu-item.logout {
  color: #DC2626;
  font-weight: 500;
}

/* Main Content Area */
.main-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background-color: white;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

/* Header - Dark Navy Background Design */
.header {
  height: 72px;
  background-color: #1e3a8a;
  display: flex;
  align-items: center;
  padding: 0 0 0 0;
  gap: 24px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  width: auto;
  justify-content: flex-start;
  padding-left: 0;
}

.status-card {
  background-color: #1e3a8a;
  color: white;
  padding: 0 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 200px;
  width: 320px;
  height: 72px;
  box-shadow: 0 2px 8px rgba(255, 111, 0, 0.3);
  cursor: pointer;
  transition: all 0.2s ease;
}

.status-title {
  font-size: 16px;
  font-weight: 600;
  opacity: 0.95;
  letter-spacing: 0.3px;
  color: white;
  font-family: 'Monaco', sans-serif;
}

.status-duration {
  font-size: 18px;
  font-weight: 700;
  font-family: 'Monaco', sans-serif;
  letter-spacing: 0.5px;
}

.status-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1;
}

.status-dropdown-icon {
  width: 16px;
  height: 16px;
  opacity: 0.8;
  transition: all 0.2s ease;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-dropdown-icon::before {
  content: '';
  position: absolute;
  width: 15px;
  height: 2px;
  background-color: white;
  transform: rotate(45deg);
  top: 0px;
  left: -6px;
}

.status-dropdown-icon::after {
  content: '';
  position: absolute;
  width: 15px;
  height: 2px;
  background-color: white;
  transform: rotate(45deg) translateY(6px);
  top: 17px;
  left: -11px;
}

.status-dropdown-icon .line1 {
  position: absolute;
  width: 15px;
  height: 2px;
  background-color: white;
  transform: rotate(135deg);
  top: 0px;
  left: -15px;
}

.status-dropdown-icon .line2 {
  position: absolute;
  width: 15px;
  height: 2px;
  background-color: white;
  transform: rotate(135deg) translateY(6px);
  top: 25px;
  left: -1px;
}

.status-dropdown-icon:hover .line1 {
  transform: rotate(45deg) translateX(2px);
}

.status-dropdown-icon:hover .line2 {
  transform: rotate(45deg) translateY(6px) translateX(-2px);
}

.status-card:hover .status-dropdown-icon {
  opacity: 1;
  transform: scale(1.1);
}

.status-card {
  position: relative;
}

/* Custom Status Dropdown */
.status-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border: 1px solid #e5e7eb;
  z-index: 1000;
  overflow: hidden;
  margin-top: 4px;
}

.status-option {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 1px solid #f3f4f6;
}

.status-option:last-child {
  border-bottom: none;
}

.status-option:hover {
  background-color: #f8fafc;
}

.status-option.active {
  background-color: #fef3c7;
  border-color: #1e3a8a;
}

.status-option.active .status-option-name {
  color: #92400e;
  font-weight: 600;
}

.status-color-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 12px;
  flex-shrink: 0;
  border: 2px solid #e5e7eb;
}

.status-option-content {
  flex: 1 1;
}

.status-option-name {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 2px;
}

.status-option-desc {
  font-size: 12px;
  color: #6b7280;
  opacity: 0.8;
}

.status-dropdown-icon {
  position: relative;
}

.status-dropdown-icon.opened .line1 {
  transform: rotate(45deg);
}

.status-dropdown-icon.opened .line2 {
  transform: rotate(-45deg);
}

.header-center {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 2px;
  max-width: 600px;
  padding: 0 20px;
}

.phone-input-container {
  flex: 0.5 1;
  position: relative;
  display: flex;
  align-items: center;
}

.phone-input {
  width: 300px;
  height: 48px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  padding: 0 20px 0 20px;
  font-size: 15px;
  font-family: 'Monaco', sans-serif;
  background-color: #FFF3E0;
  color: #24303F;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.phone-input:focus {
  outline: none;
  border-color: #FF9800;
  background-color: white;
  box-shadow: 0 0 0 4px rgba(46, 108, 181, 0.2), 0 4px 12px rgba(0, 0, 0, 0.15);
}

.phone-input::placeholder {
  color: #6B7280;
  font-weight: 400;
  margin-left: 20px;
}

.dialpad-button {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 24px;
  height: 48px;
  border: none;
  border-radius: 0 10px 10px 0;
  background-color: #f0a4c9;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 16px;
  box-shadow: none;
}

.dialpad-button:hover {
  background-color: #f0a4c9;
  color: white;
  transform: scale(1.02);
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 0px;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.queue-dropdown {
  height: 48px;
  min-width: 180px;
  border: 2px solid #152b69;
  border-radius: 10px;
  padding: 0 20px;
  font-size: 15px;
  font-family: 'Monaco', sans-serif;
  margin-left: 40px;
  font-weight: 600;
  background-color: #152b69;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(255, 111, 0, 0.3);
}

.queue-dropdown:hover {
  background-color: #94dcf0;
  border-color: #94dcf0;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(46, 108, 181, 0.4);
}

.queue-dropdown:focus {
  outline: none;
  box-shadow: 0 0 0 4px rgba(46, 108, 181, 0.3), 0 4px 12px rgba(46, 108, 181, 0.4);
}

.call-controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.call-button {
  width: 48px;
  height: 48px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  background-color: white;
  color: #0F3A6E;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.call-button:hover {
  background-color: #F9FAFB;
  border-color: #FF9800;
  color: #2E6CB5;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.call-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.call-button:disabled {
  background-color: rgba(255, 255, 255, 0.6);
  border-color: rgba(255, 255, 255, 0.3);
  color: rgba(15, 58, 110, 0.5);
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.call-button.active {
  background-color: #FF6F00;
  border-color: #FF9800;
  color: white;
}

.call-button.active:hover {
  background-color: #1E5A95;
  border-color: #FF6F00;
}

/* Main Content Layout - 2 Columns */
.content-layout {
  flex: 1 1;
  display: flex;
  background-color: #F5F7FA;
  height: 0;
  min-height: 0;
  overflow: hidden;
}

/* Left Column - Active Tasks */
.left-column {
  width: 320px;
  background-color: white;
  border-right: 1px solid #E5E7EB;
  display: flex;
  flex-direction: column;
}

.tasks-header {
  padding: 24px 20px 16px;
  border-bottom: 1px solid #E5E7EB;
}

.tasks-title {

  font-family: 'Monaco', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #24303F;
  margin-bottom: 16px;
}

.task-category {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.category-title {
  font-size: 14px;
  font-weight: 700;
  color: #24303F;
  font-family: 'Monaco', sans-serif;
}

.task-switch {
  display: flex;
  align-items: center;
  gap: 8px;
}

.switch-label {
  font-size: 12px;
  color: #6B7280;
}

.task-list {
  flex: 1 1;
  padding: 0 20px;
}

.task-item {
  display: flex;
  align-items: center;
  margin-top: 10px;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid #F3F4F6;
  background-color: #FAFBFC;
  border-radius: 8px;
  margin-bottom: 8px;
  transition: all 0.2s ease;
  border: 1px solid #E5E7EB;
}

.task-item:hover {
  background-color: #F0F9FF;
  border-color: #0EA5E9;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(14, 165, 233, 0.1);
}

.task-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #6B7280;
  background-color: #F3F4F6;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.task-content {
  flex: 1 1;
}

.task-line {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 2px;
  font-family: 'Monaco', sans-serif;
}

.task-phone {
  font-size: 11px;
  color: #6B7280;
  font-family: 'Monaco', sans-serif;
}

.task-duration {
  font-size: 11px;
  color: #059669;
  font-weight: 500;
  font-family: 'Monaco', sans-serif;
}

.task-item.active {
  background-color: #ECFDF5;
  border-color: #10B981;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15);
}

/* Bekleyen Çağrılar Section */
.queue-waiting-section {
  margin: 0 20px 8px;
  border-radius: 8px;
  border: 1px solid #FEE2E2;
  background-color: #FFF7F7;
  overflow: hidden;
}

.queue-waiting-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 12px;
  background-color: #FEF2F2;
  border-bottom: 1px solid #FEE2E2;
  font-size: 11px;
  font-weight: 600;
  color: #DC2626;
  font-family: 'Monaco', sans-serif;
}

.queue-waiting-badge {
  background-color: #DC2626;
  color: white;
  border-radius: 10px;
  padding: 1px 7px;
  font-size: 10px;
  font-weight: 700;
  min-width: 18px;
  text-align: center;
}

.queue-waiting-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  border-bottom: 1px solid #FEE2E2;
}

.queue-waiting-item:last-child {
  border-bottom: none;
}

.queue-waiting-icon {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FEE2E2;
  border-radius: 5px;
  color: #EF4444;
  flex-shrink: 0;
}

.queue-waiting-info {
  flex: 1 1;
  min-width: 0;
}

.queue-waiting-number {
  font-size: 11px;
  font-weight: 600;
  color: #374151;
  font-family: 'Monaco', sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.queue-waiting-queue {
  font-size: 10px;
  color: #9CA3AF;
  font-family: 'Monaco', sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* User Profile Section */
.user-profile {
  padding: 0px 0px;
  border-top: 1px solid #E5E7EB;
  background-color: #F9FAFB;
}

.profile-section {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.profile-info {
  flex: 1 1;
}

.profile-name-large {
  font-size: 14px;
  font-weight: 600;
  color: #24303F;
  margin-bottom: 4px;
  font-family: 'Monaco', sans-serif;
}

.profile-role {
  font-size: 12px;
  color: #6B7280;
  font-family: 'Monaco', sans-serif;
}

/* Status Counters */
.status-counters {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 0px;
}

.status-counter {
  background-color: white;
  border: 1px solid #E5E7EB;
  border-radius: 0px;
  padding: 8px;
  text-align: center;
}

.counter-value {
  font-size: 16px;
  font-weight: 600;
  color: #24303F;
  margin-bottom: 2px;
  font-family: 'Monaco', sans-serif;
}

.counter-label {
  font-size: 10px;
  color: #6B7280;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-family: 'Monaco', sans-serif;
}

.counter-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.counter-dot.ready { background-color: #059669; }
.counter-dot.talking { background-color: #059669; }
.counter-dot.waiting { background-color: #D97706; }
.counter-dot.break { background-color: #2E6CB5; }

/* Right Column - Main Content */
.right-column {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background-color: white;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

/* Tab Navigation */
.tab-navigation {
  display: flex;
  border-bottom: 1px solid #E5E7EB;
  background-color: white;
}

.tab-item {
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 500;
  color: #6B7280;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 6px;
  transition: all 0.2s ease;
  font-family: 'Monaco', sans-serif;
  display: inline-block;
  white-space: nowrap;
}

.tab-item.active {
  color: #152b69;
  border: 2px solid #152b69;
  border-radius: 8px;
  margin: 2px;

}

.tab-item:hover {
  color: #152b69;
  border: 2px solid rgba(230, 81, 0, 0.3);
  border-radius: 8px;
  margin: 2px;
}

/* Tab Content */
.tab-content {
  flex: 1 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 20px;
  overflow-y: auto;
  overflow-x: hidden;
  height: 0;
  min-height: 0;
}

.tab-content::-webkit-scrollbar {
  width: 8px;
}

.tab-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.tab-content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.tab-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.empty-state {
  text-align: center;
  max-width: 400px;
}

.empty-state-icon {
  width: 120px;
  height: 120px;
  margin: 0 auto 24px;
  background: linear-gradient(135deg, #F3F4F6 0%, #E5E7EB 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
  color: #9CA3AF;
}

.empty-state-title {
  font-size: 20px;
  font-weight: 600;
  color: #24303F;
  margin-bottom: 8px;
  font-family: 'Monaco', sans-serif;
}

.empty-state-description {
  font-size: 14px;
  color: #6B7280;
  line-height: 1.5;
  font-family: 'Monaco', sans-serif;
}

/* Active Call State */
.active-call {
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: fit-content;
}

.call-info {
  margin-bottom: 32px;
  flex-shrink: 0;
}

.customer-card-container {
  margin-top: 20px;
  width: 100%;
}

.call-number {
  font-size: 28px;
  font-weight: 700;
  color: #24303F;
  margin-bottom: 8px;
}

.call-duration {
  font-size: 16px;
  color: #6B7280;
  font-family: 'Monaco', sans-serif;
}

.call-controls {
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-shrink: 0;
  margin-top: 20px;
}

.control-button {
  width: 56px;
  height: 56px;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 20px;
}

.control-button.mute {
  background-color: #F59E0B;
  color: white;
}

.control-button.hold {
  background-color: #FF6F00;
  color: white;
}

.control-button.transfer {
  background-color: #8B5CF6;
  color: white;
}

.control-button.hangup {
  background-color: #EF4444;
  color: white;
}

.control-button:hover {
  transform: scale(1.1);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .left-column {
    width: 280px;
  }
  
  .header {
    padding: 0;
    gap: 16px;
  }
  
  .header-left {
    width: auto;
    padding-left: 0;
  }
  
  .status-card {
  }
  
  .header-center {
    padding: 0 16px;
  }
  
  .header-right {
    padding-right: 0px;
  }
  
  .header-center {
    gap: 40px;
    max-width: 400px;
  }
  
  .phone-input {
    font-size: 14px;
  }
  
  .queue-dropdown {
    min-width: 160px;
    font-size: 14px;
    padding: 0 16px;
  }
  
  .call-button {
    width: 44px;
    height: 44px;
    font-size: 18px;
  }
  
  .status-card {
    min-width: 180px;
    width: 280px;
    padding: 14px 16px;
  }
  
  .status-title {
    font-size: 14px;
  }
  
  .status-duration {
    font-size: 16px;
  }
}

@media (max-width: 768px) {
  .app-container {
    flex-direction: column;
  }
  
  .sidebar {
    width: 100%;
    height: 60px;
    flex-direction: row;
    padding: 0 20px;
  }
  
  .sidebar-menu {
    flex-direction: row;
    gap: 16px;
  }
  
  .sidebar-profile {
    margin-top: 0;
    margin-left: auto;
    flex-direction: row;
  }
  
  .content-layout {
    flex-direction: column;
  }
  
  .left-column {
    width: 100%;
    height: auto;
  }
  
  .header {
    height: auto;
    padding: 16px;
    flex-direction: column;
    gap: 16px;
  }
  
  .header-left {
    width: 100%;
    justify-content: center;
    padding-left: 0;
  }
  
  .header-center,
  .header-right {
    width: 100%;
    justify-content: center;
    padding: 0;
  }
  
  .header-center {
    max-width: 100%;
  }
  
  .phone-input-container {
    max-width: 100%;
  }
  
  .call-controls {
    justify-content: center;
  }
  
  .status-card {
    min-width: 150px;
    width: 100%;
    max-width: 280px;
    padding: 12px 16px;
    margin-left: 0;
  }
  
  .status-title {
    font-size: 13px;
  }
  
  .status-duration {
    font-size: 15px;
  }
  
  .phone-input {
    height: 44px;
    font-size: 14px;
  }
  
  .queue-dropdown {
    height: 44px;
    min-width: 140px;
    font-size: 13px;
  }
  
  .call-button {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
}

/* Header Call Controls */
.call-controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.call-button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 18px;
  background-color: #1e3772;
  color: white;
  box-shadow: 0 2px 4px rgba(30, 55, 114, 0.2);
}

.call-button:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(30, 55, 114, 0.3);
}

.call-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.call-button.active {
  background-color: #059669;
  box-shadow: 0 2px 8px rgba(5, 150, 105, 0.3);
}

.call-button.hangup {
  background-color: #EF4444;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
}

/* Customer card controls - now hidden */
.customer-card-controls {
  display: none;
}

@media (max-width: 480px) {
  .header {
    height: auto;
    padding: 12px 16px;
    flex-direction: column;
    gap: 12px;
  }
  
  .header-left {
    width: 100%;
    justify-content: center;
    padding-left: 0;
  }
  
  .header-center,
  .header-right {
    width: 100%;
    justify-content: center;
    padding: 0;
  }
  
  .status-card {
    min-width: 120px;
    width: 100%;
    max-width: 200px;
    padding: 10px 14px;
    margin-left: 0;
  }
  
  .status-title {
    font-size: 12px;
  }
  
  .status-duration {
    font-size: 14px;
  }
  
  .phone-input {
    height: 40px;
    font-size: 13px;
    padding: 0 12px 0 16px;
  }
  
  .dialpad-button {
    width: 26px;
    height: 26px;
    font-size: 12px;
    right: 6px;
  }
  
  .queue-dropdown {
    height: 40px;
    min-width: 120px;
    font-size: 12px;
    padding: 0 12px;
  }
  
  .call-button {
    width: 36px;
    height: 36px;
    font-size: 14px;
  }
  
  .tab-navigation {
    overflow-x: auto;
  }
  
  .tab-item {
    white-space: nowrap;
    padding: 12px 16px;
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AgentPanel.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,WAAW,EAAE,8BAA8B;EAC3C,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,4CAA4C;EAC5C,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,wCAAwC;EACxC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,yCAAyC;EACzC,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAS;EACT,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,iCAAiC;EACjC,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,6EAA6E;AAC/E;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iCAAiC;AACnC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sCAAsC;EACtC,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA,qBAAqB,yBAAyB,EAAE;AAChD,uBAAuB,yBAAyB,EAAE;AAClD,uBAAuB,yBAAyB,EAAE;AAClD,qBAAqB,yBAAyB,EAAE;;AAEhD,gCAAgC;AAChC;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;EACjC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;;AAEb;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,kBAAkB;EAClB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;EACA;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA,wCAAwC;AACxC;EACE,aAAa;AACf;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":["/* Modern Call Center Management Panel - Exact Specifications */\n\n/* Reset and Base Styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Monaco', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #F5F7FA;\n  color: #1e3a8a;\n  line-height: 1.5;\n}\n\n/* Main Layout Container */\n.app-container {\n  display: flex;\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n}\n\n/* Left Sidebar - Exact Specifications */\n.sidebar {\n  width: 75px; /* 70-80px range, using 75px */\n  background-color: #1e3a8a;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0px 0;\n  position: relative;\n  z-index: 1000;\n}\n\n.sidebar-logo {\n  width: 100%;\n  height: 72px;\n  background-color: #1e3a8a;\n  border-radius: 0px;\n  margin-bottom: 0px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #f09eff;\n  font-size: 12px;\n  font-weight: 600;\n  background-size: 90%;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.sidebar-menu {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  flex: 1;\n}\n\n.sidebar-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 12px 8px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: rgba(255, 255, 255, 0.7);\n  text-decoration: none;\n  min-width: 50px;\n}\n\n.sidebar-item:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n.sidebar-item.active {\n  background-color: rgba(255, 255, 255, 0.15);\n  color: white;\n}\n\n.sidebar-icon {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n}\n\n.sidebar-label {\n  font-size: 10px;\n  font-weight: 500;\n  text-align: center;\n  line-height: 1.2;\n}\n\n.sidebar-profile {\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 20px;\n  position: relative;\n  cursor: pointer;\n}\n\n.profile-avatar {\n  width: 36px;\n  height: 36px;\n  background-color: rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.profile-name {\n  font-size: 9px;\n  color: rgba(255, 255, 255, 0.8);\n  text-align: center;\n  line-height: 1.2;\n}\n\n/* Profile Menu */\n.profile-menu {\n  position: absolute;\n  top: -60px;\n  left: 100%;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border: 1px solid #E5E7EB;\n  z-index: 1000;\n  min-width: 180px;\n  margin-left: 18px;\n  overflow: hidden;\n}\n\n.profile-menu-item {\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  color: #374151;\n  border-bottom: 1px solid #F3F4F6;\n}\n\n.profile-menu-item:last-child {\n  border-bottom: none;\n}\n\n.profile-menu-item:hover {\n  background-color: #F9FAFB;\n}\n\n.profile-menu-item-icon {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n}\n\n.profile-menu-item.logout {\n  color: #DC2626;\n  font-weight: 500;\n}\n\n/* Main Content Area */\n.main-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* Header - Dark Navy Background Design */\n.header {\n  height: 72px;\n  background-color: #1e3a8a;\n  display: flex;\n  align-items: center;\n  padding: 0 0 0 0;\n  gap: 24px;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: auto;\n  justify-content: flex-start;\n  padding-left: 0;\n}\n\n.status-card {\n  background-color: #1e3a8a;\n  color: white;\n  padding: 0 20px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  min-width: 200px;\n  width: 320px;\n  height: 72px;\n  box-shadow: 0 2px 8px rgba(255, 111, 0, 0.3);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.status-title {\n  font-size: 16px;\n  font-weight: 600;\n  opacity: 0.95;\n  letter-spacing: 0.3px;\n  color: white;\n  font-family: 'Monaco', sans-serif;\n}\n\n.status-duration {\n  font-size: 18px;\n  font-weight: 700;\n  font-family: 'Monaco', sans-serif;\n  letter-spacing: 0.5px;\n}\n\n.status-content {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n}\n\n.status-dropdown-icon {\n  width: 16px;\n  height: 16px;\n  opacity: 0.8;\n  transition: all 0.2s ease;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.status-dropdown-icon::before {\n  content: '';\n  position: absolute;\n  width: 15px;\n  height: 2px;\n  background-color: white;\n  transform: rotate(45deg);\n  top: 0px;\n  left: -6px;\n}\n\n.status-dropdown-icon::after {\n  content: '';\n  position: absolute;\n  width: 15px;\n  height: 2px;\n  background-color: white;\n  transform: rotate(45deg) translateY(6px);\n  top: 17px;\n  left: -11px;\n}\n\n.status-dropdown-icon .line1 {\n  position: absolute;\n  width: 15px;\n  height: 2px;\n  background-color: white;\n  transform: rotate(135deg);\n  top: 0px;\n  left: -15px;\n}\n\n.status-dropdown-icon .line2 {\n  position: absolute;\n  width: 15px;\n  height: 2px;\n  background-color: white;\n  transform: rotate(135deg) translateY(6px);\n  top: 25px;\n  left: -1px;\n}\n\n.status-dropdown-icon:hover .line1 {\n  transform: rotate(45deg) translateX(2px);\n}\n\n.status-dropdown-icon:hover .line2 {\n  transform: rotate(45deg) translateY(6px) translateX(-2px);\n}\n\n.status-card:hover .status-dropdown-icon {\n  opacity: 1;\n  transform: scale(1.1);\n}\n\n.status-card {\n  position: relative;\n}\n\n/* Custom Status Dropdown */\n.status-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  border: 1px solid #e5e7eb;\n  z-index: 1000;\n  overflow: hidden;\n  margin-top: 4px;\n}\n\n.status-option {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.status-option:last-child {\n  border-bottom: none;\n}\n\n.status-option:hover {\n  background-color: #f8fafc;\n}\n\n.status-option.active {\n  background-color: #fef3c7;\n  border-color: #1e3a8a;\n}\n\n.status-option.active .status-option-name {\n  color: #92400e;\n  font-weight: 600;\n}\n\n.status-color-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  margin-right: 12px;\n  flex-shrink: 0;\n  border: 2px solid #e5e7eb;\n}\n\n.status-option-content {\n  flex: 1;\n}\n\n.status-option-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 2px;\n}\n\n.status-option-desc {\n  font-size: 12px;\n  color: #6b7280;\n  opacity: 0.8;\n}\n\n.status-dropdown-icon {\n  position: relative;\n}\n\n.status-dropdown-icon.opened .line1 {\n  transform: rotate(45deg);\n}\n\n.status-dropdown-icon.opened .line2 {\n  transform: rotate(-45deg);\n}\n\n.header-center {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  max-width: 600px;\n  padding: 0 20px;\n}\n\n.phone-input-container {\n  flex: 0.5;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.phone-input {\n  width: 300px;\n  height: 48px;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 10px;\n  padding: 0 20px 0 20px;\n  font-size: 15px;\n  font-family: 'Monaco', sans-serif;\n  background-color: #FFF3E0;\n  color: #24303F;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.phone-input:focus {\n  outline: none;\n  border-color: #FF9800;\n  background-color: white;\n  box-shadow: 0 0 0 4px rgba(46, 108, 181, 0.2), 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.phone-input::placeholder {\n  color: #6B7280;\n  font-weight: 400;\n  margin-left: 20px;\n}\n\n.dialpad-button {\n  position: absolute;\n  right: 0px;\n  top: 0px;\n  width: 24px;\n  height: 48px;\n  border: none;\n  border-radius: 0 10px 10px 0;\n  background-color: #f0a4c9;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 16px;\n  box-shadow: none;\n}\n\n.dialpad-button:hover {\n  background-color: #f0a4c9;\n  color: white;\n  transform: scale(1.02);\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-right: 0px;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n}\n\n.queue-dropdown {\n  height: 48px;\n  min-width: 180px;\n  border: 2px solid #152b69;\n  border-radius: 10px;\n  padding: 0 20px;\n  font-size: 15px;\n  font-family: 'Monaco', sans-serif;\n  margin-left: 40px;\n  font-weight: 600;\n  background-color: #152b69;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(255, 111, 0, 0.3);\n}\n\n.queue-dropdown:hover {\n  background-color: #94dcf0;\n  border-color: #94dcf0;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(46, 108, 181, 0.4);\n}\n\n.queue-dropdown:focus {\n  outline: none;\n  box-shadow: 0 0 0 4px rgba(46, 108, 181, 0.3), 0 4px 12px rgba(46, 108, 181, 0.4);\n}\n\n.call-controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.call-button {\n  width: 48px;\n  height: 48px;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  background-color: white;\n  color: #0F3A6E;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.call-button:hover {\n  background-color: #F9FAFB;\n  border-color: #FF9800;\n  color: #2E6CB5;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n}\n\n.call-button:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.call-button:disabled {\n  background-color: rgba(255, 255, 255, 0.6);\n  border-color: rgba(255, 255, 255, 0.3);\n  color: rgba(15, 58, 110, 0.5);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.call-button.active {\n  background-color: #FF6F00;\n  border-color: #FF9800;\n  color: white;\n}\n\n.call-button.active:hover {\n  background-color: #1E5A95;\n  border-color: #FF6F00;\n}\n\n/* Main Content Layout - 2 Columns */\n.content-layout {\n  flex: 1;\n  display: flex;\n  background-color: #F5F7FA;\n  height: 0;\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* Left Column - Active Tasks */\n.left-column {\n  width: 320px;\n  background-color: white;\n  border-right: 1px solid #E5E7EB;\n  display: flex;\n  flex-direction: column;\n}\n\n.tasks-header {\n  padding: 24px 20px 16px;\n  border-bottom: 1px solid #E5E7EB;\n}\n\n.tasks-title {\n\n  font-family: 'Monaco', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  color: #24303F;\n  margin-bottom: 16px;\n}\n\n.task-category {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.category-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #24303F;\n  font-family: 'Monaco', sans-serif;\n}\n\n.task-switch {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.switch-label {\n  font-size: 12px;\n  color: #6B7280;\n}\n\n.task-list {\n  flex: 1;\n  padding: 0 20px;\n}\n\n.task-item {\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n  gap: 12px;\n  padding: 12px 16px;\n  border-bottom: 1px solid #F3F4F6;\n  background-color: #FAFBFC;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  transition: all 0.2s ease;\n  border: 1px solid #E5E7EB;\n}\n\n.task-item:hover {\n  background-color: #F0F9FF;\n  border-color: #0EA5E9;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(14, 165, 233, 0.1);\n}\n\n.task-icon {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  color: #6B7280;\n  background-color: #F3F4F6;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.task-content {\n  flex: 1;\n}\n\n.task-line {\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 2px;\n  font-family: 'Monaco', sans-serif;\n}\n\n.task-phone {\n  font-size: 11px;\n  color: #6B7280;\n  font-family: 'Monaco', sans-serif;\n}\n\n.task-duration {\n  font-size: 11px;\n  color: #059669;\n  font-weight: 500;\n  font-family: 'Monaco', sans-serif;\n}\n\n.task-item.active {\n  background-color: #ECFDF5;\n  border-color: #10B981;\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15);\n}\n\n/* Bekleyen Çağrılar Section */\n.queue-waiting-section {\n  margin: 0 20px 8px;\n  border-radius: 8px;\n  border: 1px solid #FEE2E2;\n  background-color: #FFF7F7;\n  overflow: hidden;\n}\n\n.queue-waiting-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px 12px;\n  background-color: #FEF2F2;\n  border-bottom: 1px solid #FEE2E2;\n  font-size: 11px;\n  font-weight: 600;\n  color: #DC2626;\n  font-family: 'Monaco', sans-serif;\n}\n\n.queue-waiting-badge {\n  background-color: #DC2626;\n  color: white;\n  border-radius: 10px;\n  padding: 1px 7px;\n  font-size: 10px;\n  font-weight: 700;\n  min-width: 18px;\n  text-align: center;\n}\n\n.queue-waiting-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px;\n  border-bottom: 1px solid #FEE2E2;\n}\n\n.queue-waiting-item:last-child {\n  border-bottom: none;\n}\n\n.queue-waiting-icon {\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #FEE2E2;\n  border-radius: 5px;\n  color: #EF4444;\n  flex-shrink: 0;\n}\n\n.queue-waiting-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.queue-waiting-number {\n  font-size: 11px;\n  font-weight: 600;\n  color: #374151;\n  font-family: 'Monaco', sans-serif;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.queue-waiting-queue {\n  font-size: 10px;\n  color: #9CA3AF;\n  font-family: 'Monaco', sans-serif;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* User Profile Section */\n.user-profile {\n  padding: 0px 0px;\n  border-top: 1px solid #E5E7EB;\n  background-color: #F9FAFB;\n}\n\n.profile-section {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.profile-info {\n  flex: 1;\n}\n\n.profile-name-large {\n  font-size: 14px;\n  font-weight: 600;\n  color: #24303F;\n  margin-bottom: 4px;\n  font-family: 'Monaco', sans-serif;\n}\n\n.profile-role {\n  font-size: 12px;\n  color: #6B7280;\n  font-family: 'Monaco', sans-serif;\n}\n\n/* Status Counters */\n.status-counters {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  gap: 0px;\n}\n\n.status-counter {\n  background-color: white;\n  border: 1px solid #E5E7EB;\n  border-radius: 0px;\n  padding: 8px;\n  text-align: center;\n}\n\n.counter-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #24303F;\n  margin-bottom: 2px;\n  font-family: 'Monaco', sans-serif;\n}\n\n.counter-label {\n  font-size: 10px;\n  color: #6B7280;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  font-family: 'Monaco', sans-serif;\n}\n\n.counter-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n}\n\n.counter-dot.ready { background-color: #059669; }\n.counter-dot.talking { background-color: #059669; }\n.counter-dot.waiting { background-color: #D97706; }\n.counter-dot.break { background-color: #2E6CB5; }\n\n/* Right Column - Main Content */\n.right-column {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* Tab Navigation */\n.tab-navigation {\n  display: flex;\n  border-bottom: 1px solid #E5E7EB;\n  background-color: white;\n}\n\n.tab-item {\n  padding: 8px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #6B7280;\n  cursor: pointer;\n  border: 2px solid transparent;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  font-family: 'Monaco', sans-serif;\n  display: inline-block;\n  white-space: nowrap;\n}\n\n.tab-item.active {\n  color: #152b69;\n  border: 2px solid #152b69;\n  border-radius: 8px;\n  margin: 2px;\n\n}\n\n.tab-item:hover {\n  color: #152b69;\n  border: 2px solid rgba(230, 81, 0, 0.3);\n  border-radius: 8px;\n  margin: 2px;\n}\n\n/* Tab Content */\n.tab-content {\n  flex: 1;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 20px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: 0;\n  min-height: 0;\n}\n\n.tab-content::-webkit-scrollbar {\n  width: 8px;\n}\n\n.tab-content::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.tab-content::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 10px;\n}\n\n.tab-content::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.empty-state {\n  text-align: center;\n  max-width: 400px;\n}\n\n.empty-state-icon {\n  width: 120px;\n  height: 120px;\n  margin: 0 auto 24px;\n  background: linear-gradient(135deg, #F3F4F6 0%, #E5E7EB 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 48px;\n  color: #9CA3AF;\n}\n\n.empty-state-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #24303F;\n  margin-bottom: 8px;\n  font-family: 'Monaco', sans-serif;\n}\n\n.empty-state-description {\n  font-size: 14px;\n  color: #6B7280;\n  line-height: 1.5;\n  font-family: 'Monaco', sans-serif;\n}\n\n/* Active Call State */\n.active-call {\n  text-align: center;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  min-height: fit-content;\n}\n\n.call-info {\n  margin-bottom: 32px;\n  flex-shrink: 0;\n}\n\n.customer-card-container {\n  margin-top: 20px;\n  width: 100%;\n}\n\n.call-number {\n  font-size: 28px;\n  font-weight: 700;\n  color: #24303F;\n  margin-bottom: 8px;\n}\n\n.call-duration {\n  font-size: 16px;\n  color: #6B7280;\n  font-family: 'Monaco', sans-serif;\n}\n\n.call-controls {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  flex-shrink: 0;\n  margin-top: 20px;\n}\n\n.control-button {\n  width: 56px;\n  height: 56px;\n  border: none;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 20px;\n}\n\n.control-button.mute {\n  background-color: #F59E0B;\n  color: white;\n}\n\n.control-button.hold {\n  background-color: #FF6F00;\n  color: white;\n}\n\n.control-button.transfer {\n  background-color: #8B5CF6;\n  color: white;\n}\n\n.control-button.hangup {\n  background-color: #EF4444;\n  color: white;\n}\n\n.control-button:hover {\n  transform: scale(1.1);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .left-column {\n    width: 280px;\n  }\n  \n  .header {\n    padding: 0;\n    gap: 16px;\n  }\n  \n  .header-left {\n    width: auto;\n    padding-left: 0;\n  }\n  \n  .status-card {\n  }\n  \n  .header-center {\n    padding: 0 16px;\n  }\n  \n  .header-right {\n    padding-right: 0px;\n  }\n  \n  .header-center {\n    gap: 40px;\n    max-width: 400px;\n  }\n  \n  .phone-input {\n    font-size: 14px;\n  }\n  \n  .queue-dropdown {\n    min-width: 160px;\n    font-size: 14px;\n    padding: 0 16px;\n  }\n  \n  .call-button {\n    width: 44px;\n    height: 44px;\n    font-size: 18px;\n  }\n  \n  .status-card {\n    min-width: 180px;\n    width: 280px;\n    padding: 14px 16px;\n  }\n  \n  .status-title {\n    font-size: 14px;\n  }\n  \n  .status-duration {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .app-container {\n    flex-direction: column;\n  }\n  \n  .sidebar {\n    width: 100%;\n    height: 60px;\n    flex-direction: row;\n    padding: 0 20px;\n  }\n  \n  .sidebar-menu {\n    flex-direction: row;\n    gap: 16px;\n  }\n  \n  .sidebar-profile {\n    margin-top: 0;\n    margin-left: auto;\n    flex-direction: row;\n  }\n  \n  .content-layout {\n    flex-direction: column;\n  }\n  \n  .left-column {\n    width: 100%;\n    height: auto;\n  }\n  \n  .header {\n    height: auto;\n    padding: 16px;\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .header-left {\n    width: 100%;\n    justify-content: center;\n    padding-left: 0;\n  }\n  \n  .header-center,\n  .header-right {\n    width: 100%;\n    justify-content: center;\n    padding: 0;\n  }\n  \n  .header-center {\n    max-width: 100%;\n  }\n  \n  .phone-input-container {\n    max-width: 100%;\n  }\n  \n  .call-controls {\n    justify-content: center;\n  }\n  \n  .status-card {\n    min-width: 150px;\n    width: 100%;\n    max-width: 280px;\n    padding: 12px 16px;\n    margin-left: 0;\n  }\n  \n  .status-title {\n    font-size: 13px;\n  }\n  \n  .status-duration {\n    font-size: 15px;\n  }\n  \n  .phone-input {\n    height: 44px;\n    font-size: 14px;\n  }\n  \n  .queue-dropdown {\n    height: 44px;\n    min-width: 140px;\n    font-size: 13px;\n  }\n  \n  .call-button {\n    width: 40px;\n    height: 40px;\n    font-size: 16px;\n  }\n}\n\n/* Header Call Controls */\n.call-controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.call-button {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 18px;\n  background-color: #1e3772;\n  color: white;\n  box-shadow: 0 2px 4px rgba(30, 55, 114, 0.2);\n}\n\n.call-button:hover {\n  transform: scale(1.1);\n  box-shadow: 0 4px 8px rgba(30, 55, 114, 0.3);\n}\n\n.call-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.call-button.active {\n  background-color: #059669;\n  box-shadow: 0 2px 8px rgba(5, 150, 105, 0.3);\n}\n\n.call-button.hangup {\n  background-color: #EF4444;\n  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);\n}\n\n/* Customer card controls - now hidden */\n.customer-card-controls {\n  display: none;\n}\n\n@media (max-width: 480px) {\n  .header {\n    height: auto;\n    padding: 12px 16px;\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .header-left {\n    width: 100%;\n    justify-content: center;\n    padding-left: 0;\n  }\n  \n  .header-center,\n  .header-right {\n    width: 100%;\n    justify-content: center;\n    padding: 0;\n  }\n  \n  .status-card {\n    min-width: 120px;\n    width: 100%;\n    max-width: 200px;\n    padding: 10px 14px;\n    margin-left: 0;\n  }\n  \n  .status-title {\n    font-size: 12px;\n  }\n  \n  .status-duration {\n    font-size: 14px;\n  }\n  \n  .phone-input {\n    height: 40px;\n    font-size: 13px;\n    padding: 0 12px 0 16px;\n  }\n  \n  .dialpad-button {\n    width: 26px;\n    height: 26px;\n    font-size: 12px;\n    right: 6px;\n  }\n  \n  .queue-dropdown {\n    height: 40px;\n    min-width: 120px;\n    font-size: 12px;\n    padding: 0 12px;\n  }\n  \n  .call-button {\n    width: 36px;\n    height: 36px;\n    font-size: 14px;\n  }\n  \n  .tab-navigation {\n    overflow-x: auto;\n  }\n  \n  .tab-item {\n    white-space: nowrap;\n    padding: 12px 16px;\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
